export default __webpack_public_path__ + "static/SourceCodePro.bold-6bece39e186fc5918967943b2b05b280.woff2";